import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: any) => ({
  textBelowActions: {
    fontFamily: theme.typography.fontFamilySecondary,
  },
}));

export default function DialogTextBelowActions(props) {
  const classes = useStyles();

  return <div className={classes.textBelowActions}>{props.children}</div>;
}
